import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { InitialTestimonials } from './components/InitialTestimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { TomosSection } from './components/TomosSection';
import { BonusesSection } from './components/BonusesSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingSection } from './components/PricingSection';
import { EliteCoachDetails } from './components/EliteCoachDetails';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalComparison } from './components/FinalComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark-900 text-gray-100 font-sans selection:bg-lime-500 selection:text-dark-900" data-id="element-0">
      <Hero data-id="element-1" />
      <StatsBar data-id="element-2" />
      <InitialTestimonials data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductOverview data-id="element-5" />
      <TomosSection data-id="element-6" />
      <BonusesSection data-id="element-7" />
      <CountdownTimer data-id="element-8" />
      <PricingSection data-id="element-9" />
      <EliteCoachDetails data-id="element-10" />
      <ExtendedTestimonials data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <FinalComparison data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <Footer data-id="element-16" />
    </div>;
}